import { ArrowLeft } from "@material-ui/icons";
import React from "react";

type Props = {
  setStep: (step: number) => void;
};

const StepThree = ({ setStep }: Props) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <p>
        Une fois les 6 points sélectionnés, les 2 polygones vont se coller
        automatiquement.
        <br />
        Le second polygone sélectionné va se coller sur le premier, et toujours
        dans cet ordre.
        <br />
        Si vous n'êtes pas satisfait du collage, vous pouvez revenir à l'état
        précedent en cliquant sur l'icône retour.
        <br />
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
          }}
        >
          <img src="/undo.png" alt="undo" width="90" height="30" />
        </div>
        <br />
        Voici un exemple de ce que vous pouvez obtenir :
      </p>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
        }}
      >
        <img src="/help.gif" alt="help" width="400" height="400" />
      </div>
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          cursor: "pointer",
        }}
        onClick={() => setStep(2)}
      >
        <ArrowLeft /> Étape 2
      </div>
    </div>
  );
};

export default StepThree;
